document.addEventListener('DOMContentLoaded', () => {
	const header = document.querySelector('.site-header');

	if (header && header.classList.contains('is-sticky')) {
		if (window.scrollY > 100) {
			header.classList.add('scrolled');
		} else {
			header.classList.remove('scrolled');
		}
		window.addEventListener('scroll', () => {
			if (window.scrollY > 100) {
				header.classList.add('scrolled');
			} else {
				header.classList.remove('scrolled');
			}
		});
	}
});
